import templateUrl from 'emun.blog/blog-banner.htm'
import AutoQuery from 'servicestack/auto-query/auto-query'
import basicController from 'servicestack/basic.controller.properties'
import $session from 'servicestack/session'
import resolve from 'ioc/resolve'
import BlogView from 'emun.blog/blog-view'

class BlogBannerController {
    constructor($scope) {
        const $ctrl = this;
        basicController($ctrl);
        let $rootScope = resolve('$rootScope');
        $rootScope.$on('activitySaved', () => $ctrl.query.load(true));
        $rootScope.$on('activityDeleted', () => $ctrl.query.load(true));
    }
    $onInit(){
        const $ctrl = this;

		$ctrl.query = new AutoQuery({
            url: 'QueryBlogs.json',
            tagTotalsUrl: 'QueryBlogTagTotals.json',
            hideLeftNav: true, // $ctrl.$pageConfig.is('gt-sm'),
			orderBy: '-CreatedOn,Id',
            sortOptions:{
				'CreatedOn,Id': 'Created: Newest',
				'-CreatedOn,Id': 'Created: Oldest'
            },
            criteria: {
                onlyNew: true
            },
            filters: [
                {tag: 'Category', title: 'Category'},
            ],
            autoLoad: true,
            pageSize: 12,
            onLoaded: function(args) {
                $ctrl.$session.storage.NewMessages = args.results.filter(r => !r.isRead).length;
            }
        });
        if (!$ctrl.view) $ctrl.view = "card";
    }
    load(){
        const $ctrl = this;
        $ctrl.query.load(true);
    }
    viewBlog(blog){
        const $ctrl = this;
        blog.isRead = true;
        BlogView.open({blog: blog}).then(() => $ctrl.load());
    }
    toggleUnread() {
        const $ctrl = this;
        if ($ctrl.query.criteria.onlyNew) {
          $ctrl.query.criteria.onlyNew = false;
        } else {
          $ctrl.query.criteria.onlyNew = true;
        }
        $ctrl.query.load(true);
      }
    }

export default BlogBannerController;